import React from 'react';
import { ExperienceType } from '../../../../enums/experience';
import { useFormState } from '../useFormState';
import AvailabilityModeSection from '../../Owner/SharedComponents/AvailabilityModeSection';
import LinkCalendars from '../../Owner/SharedComponents/LinkCalendars';
import AddOnsSection from '../../Owner/SharedComponents/AddOnsSection';
import { Stack, Typography } from '@mui/material';
import PartnerServicesSection from './PartnerServicesSection';

const ExperienceIntegrations = () => {
    const { experience } = useFormState();

    return (
        <Stack spacing={2}>
            <div>
                <Typography variant='h2'>Integrations (optional)</Typography>
                <Typography sx={{ color: 'text.secondary' }} gutterBottom>
                    Link your experience to other services to enhance the guest
                    experience.
                </Typography>
            </div>
            {[ExperienceType.Vehicle, ExperienceType.Activity].includes(
                experience.type,
            ) && <AvailabilityModeSection />}
            {[ExperienceType.Commercial, ExperienceType.Property].includes(
                experience.type,
            ) && <AddOnsSection />}
            {[
                ExperienceType.Property,
                ExperienceType.Commercial,
                ExperienceType.Boat,
            ].includes(experience.type) && <PartnerServicesSection />}

            {experience.type === ExperienceType.Property && (
                <LinkCalendars existingModule={experience} />
            )}
        </Stack>
    );
};

export default ExperienceIntegrations;
